import React from 'react';
import { bool, func, node, oneOf, string } from 'prop-types';

import classes from './InteractiveIcon.module.css';

const InteractiveIcon = ({
    children,
    className,
    hidden,
    icon,
    iconClassName,
    iconSet,
    iconPath,
    label,
    onClick
}) => {
    if (hidden) {
        return null;
    }
    return (
        <button
            aria-label={label}
            className={`${classes.InteractiveIcon} ${className}`}
            onClick={onClick}
        >
            {!iconPath && <i className={`${iconSet} ${icon} ${iconClassName}`}>{children}</i>}
            {iconPath && <img src={iconPath} alt={label} />}
        </button>
    );
};

InteractiveIcon.defaultProps = {
    hidden:        false,
    icon:          '',
    iconClassName: '',
    iconSet:       '',
    iconPath:      null,
    onClick:       () => {}
};

InteractiveIcon.propTypes = {
    children:      node,
    className:     string,
    hidden:        bool,
    icon:          string,
    iconClassName: string,
    iconSet:       oneOf(['fas', '']),
    iconPath:      string,
    label:         string.isRequired,
    onClick:       func.isRequired
};

export default InteractiveIcon;
